import { Button, BUTTON_THEME, Icon } from '@st-operations/uikit/src/v2'
import React, { useMemo } from 'react'
import { useEffect } from 'react'

import MultiValueInput from '_components/multi-value-input/index.jsx'
import useTotalUsers from '../hooks/useTotalUsers.js'
import MonthlyUserCount from '../monthly-user-count/index.jsx'

import './styles.scss'

const EventFeedsWizardDomain = ({
  onBackClick,
  domains,
  onDomainsChange,
  onSkip,
  onAddDomains,
  cumulativeFilters,
  onCumulativeFiltersChange,
}) => {
  const payload = useMemo(() => {
    const withoutDomains = cumulativeFilters.filter((f) => f.key !== 'domain')
    return domains?.length > 0
      ? { filters: [...withoutDomains, { key: 'domain', operator: 'similar_to', value: domains }] }
      : { filters: [...withoutDomains] }
  }, [domains])
  const [totalUsers] = useTotalUsers(payload)

  useEffect(() => {
    if (onCumulativeFiltersChange) {
      onCumulativeFiltersChange(payload.filters)
    }
  }, [payload])

  return (
    <div className="event-feeds-wizard-domain__container">
      <Button
        theme={BUTTON_THEME.GHOST}
        onClick={onBackClick}
        className="event-feeds-wizard-domain__back-button"
      >
        <Icon type="outline" icon="angleleft" />
        Back
      </Button>
      <span className="event-feeds-wizard-domain__title">{`6. I'm interested in domains similar to:`}</span>
      <MultiValueInput
        name="value"
        className="event-feeds-wizard-domain__input"
        values={domains}
        onChange={(value) => {
          onDomainsChange(value)
        }}
      />
      <MonthlyUserCount totalUsers={totalUsers} />
      <Button theme={BUTTON_THEME.GHOST} onClick={onSkip}>
        Skip
      </Button>
      <div className="event-feeds-wizard-domain__add-terms-container">
        <Button
          className="event-feeds-wizard-domain__add-terms-button"
          disabled={domains.length === 0}
          onClick={onAddDomains}
        >
          Add Domain
        </Button>
      </div>
    </div>
  )
}

export default EventFeedsWizardDomain
